import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { StepContainer } from '../../components/StepContainer/StepContainer';
import { StepFooter } from '../../components/StepFooter/StepFooter';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { FormValues, STEP_ID, validation } from './KindOfProperty.meta';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { INPUTS_WIDTH } from '../../CharitableGiving.meta';
import { useNavigation } from '../../hooks/useNavigation';
import { WorkflowDTO } from '../../api/useCharitableGivingQuery';

export const KindOfProperty = () => {
  const { workflow, setWorkflow, setStep } = useCharitableGivingContext();

  const { progress, previousStep, nextStep, isFirstStep } = useNavigation({ currentStep: STEP_ID });

  const { control, handleSubmit, formState } = useForm<FormValues>({
    defaultValues: {
      kindOfProperty: workflow.data.kindOfProperty,
    },
    resolver: yupResolver(validation),
  });

  const onSubmit = handleSubmit(values => {
    const newWorkflow: WorkflowDTO = {
      ...workflow,
      data: {
        ...workflow.data,
        kindOfProperty: values.kindOfProperty,
      },
    };

    setWorkflow(newWorkflow);

    if (nextStep) {
      setStep(nextStep);
    }
  });

  const { kindOfPropertyOptions } = workflow.options;

  return (
    <StepContainer
      title="What kind of property would you like to donate?"
      onSubmit={onSubmit}
      footer={
        <StepFooter
          isFirstStep={isFirstStep}
          progress={progress}
          onPrevious={previousStep ? () => setStep(previousStep) : undefined}
        />
      }
    >
      <Controller
        control={control}
        name="kindOfProperty"
        render={({ field: { value: formValue, onChange, ref } }) => (
          <Box style={{ width: INPUTS_WIDTH }}>
            <Select
              innerRef={ref}
              label="Property"
              value={kindOfPropertyOptions.find(({ value }) => value === formValue)}
              onChange={opt => onChange(opt?.value)}
              options={kindOfPropertyOptions}
              formVariant={formState.errors.kindOfProperty ? 'error' : undefined}
              helperText={formState.errors.kindOfProperty?.message}
            />
          </Box>
        )}
      />
    </StepContainer>
  );
};
